import store from '../store';
import { oAuth } from '@libs/wechat';

export default function toLogin() {
    store.commit('LOGOUT');
    return oAuth();
}
